"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Invite = void 0;
var Invite;
(function (Invite) {
    function createId(assignmentId, userId) {
        return `${assignmentId}-${userId}`;
    }
    Invite.createId = createId;
    function create(meta, userId) {
        return {
            _id: createId(meta._id, userId),
            assignmentId: meta._id,
            userId,
            title: meta.assignmentInfo.name || '',
            type: 'realtimeAssignment',
            createdAt: Date.now(),
        };
    }
    Invite.create = create;
})(Invite || (exports.Invite = Invite = {}));
//# sourceMappingURL=Invite.js.map